import axios from 'axios';
import { SetterOrUpdater, useRecoilState } from 'recoil';
import { Preorder } from '../../models/Preorder.model';
import dayjs, { Dayjs } from 'dayjs';
import { assetPathFn, howManyDaysAwayFromToday, isAfterToday, parseStringAsAmericaLosAngelesTimezone } from '../../util';
import { preorderState } from '../../recoil/atoms';

let preOrdersFetched = false;

export const useSharedGetPreorderState = (): Preorder[] => {
  const [preorders, set] = useRecoilState(preorderState);
  if (!preOrdersFetched) {
    preOrdersFetched = true;
    fetchPreorders(set);
  }
  return preorders;
};

export const fetchPreorders = (set: SetterOrUpdater<Preorder[]>): void => {
  const preorderTextFn = (date: Dayjs) => {
    const daysAway = howManyDaysAwayFromToday(date) || 1;
    const shipsInCopy = daysAway < 7 ? `(Ships in ${daysAway} day${daysAway === 1 ? '' : 's'})` : `(Ships ${dayjs(date).format('MMM D')})`;
    return isAfterToday(date) ? shipsInCopy : undefined;
  };
  const prepPreorders = (items: Preorder[]) =>
    items.map((po: { date: string; sku: string }) => {
      const shippingDayJs = parseStringAsAmericaLosAngelesTimezone(po.date);
      return {
        ...po,
        isPreorder: true,
        preorderText: preorderTextFn(shippingDayJs),
      } as Preorder;
    });

  axios
    .get(assetPathFn('pre-order.json'))
    .then((response) => {
      set(prepPreorders(response.data));
    })
    .catch(() => {
      // eslint-disable-next-line no-console
      console.log('Error fetching preorders');
    });
};
